import stepOneImg from "../../../image/realestate/step-img-one.webp";
import stepTwoImg from "../../../image/realestate/step-img-two.webp";
import stepThreeImg from "../../../image/realestate/step-img-three.webp";
import stepFourImg from "../../../image/realestate/step-img-four.webp";
import stepFiveImg from "../../../image/realestate/step-img-five.webp";

export const steps = [
  {
    imageSrc: stepOneImg,
    title: "Choose a Blockchain Platform",
    content:
      "Ethereum, Binance Smart Chain, and Polygon are popular choices for real estate tokenization.",
  },
  {
    imageSrc: stepTwoImg,
    title: "Develop a Smart Contract",
    content:
      "Smart contracts are used to automate ownership transfers, payments, and compliance.",
  },
  {
    imageSrc: stepThreeImg,
    title: "Ensure Regulatory Compliance",
    content:
      "Consulting legal experts to adhere to real estate and securities regulations is crucial.",
  },
  {
    imageSrc: stepFourImg,
    title: "Conduct a Security Token Offering (STO)",
    content:
      "A Security Token Offering (STO) is a method for selling tokenized real estate assets to investors.",
  },
  {
    imageSrc: stepFiveImg,
    title: "Enable Secondary Market Trading",
    content:
      "Listing tokenized assets on digital exchanges enhances liquidity and market accessibility.",
  },
];

export const benefits = [
  {
    id: 1,
    img: require("../../../image/realestate/ben-img-one.webp"),
    title: "Increased Liquidity",
    content:
      "Traditional real estate investments are illiquid, requiring months or years to sell a property. With real estate tokenization, investors can buy or sell tokens in seconds, enhancing liquidity.",
  },
  {
    id: 2,
    img: require("../../../image/realestate/ben-img-two.webp"),
    title: "Fractional Ownership",
    content:
      "Real estate tokenization allows investors to purchase a fraction of a property rather than the entire asset, reducing entry barriers and making investment more accessible.",
  },
  {
    id: 3,
    img: require("../../../image/realestate/ben-img-three.webp"),
    title: "Transparency & Security",
    content:
      "Blockchain technology ensures that real estate tokenization transactions are immutable, traceable, and secure, reducing fraud risks.",
  },
  {
    id: 4,
    img: require("../../../image/realestate/ben-img-four.webp"),
    title: "Lower Transaction Costs",
    content:
      "By eliminating intermediaries such as brokers and banks, real estate tokenization significantly reduces transaction costs and speeds up investment processes.",
  },
];
